import React from "react";

import { Svg } from "./partials/Svg";
import { Group } from "./partials/Group";
import { Header } from "./partials/Header";
import { Key, Legend } from "./partials/Legend";
import { InfoSymbol } from "./partials/InfoSymbol";
import { StackedBarChart } from "./partials/StackedBarChart";
import { ChartProps } from "./Chart";

import { chartColors } from "../../config/colors";
import { margin } from "../../config/spacing";

import energyMixData from "./data/energy-mix.json";

export const EnergyMix: React.FC<ChartProps> = ({
  id,
  width = 250,
  height = 400,
  isAnimated = true,
}) => {
  const innerWidth = width - margin.left - margin.right;

  return (
    <Svg id={id} width={width} height={height}>
      <Group transform={`translate(${margin.left}, ${margin.top})`}>
        <Header
          title={"Energiemix"}
          description={
            "Aus welchen Quellen wird der\nStrom in Deutschland erzeugt?"
          }
        />
        <InfoSymbol
          link={"https://www.ardalpha.de/klimazahlen-energiemix-102.html"}
          transform={`translate(${innerWidth - 15}, ${-5})`}
        />
        <Group transform={`translate(0, 80)`}>
          <Legend>
            <Key
              text="Kohle"
              symbol="square"
              symbolFill={chartColors.veryDarkGrey}
            />
            <Key
              text="Gas"
              symbol="square"
              symbolFill={chartColors.purple}
              transform={`translate(73, 0)`}
            />
            <Key
              text="Nuklear"
              symbol="square"
              symbolFill={chartColors.orange}
              transform={`translate(135, 0)`}
            />
            <Key
              text="Erneuerbare"
              symbol="square"
              symbolFill={chartColors.green}
              transform={`translate(0, 20)`}
            />
            <Key
              text="Sonstige"
              symbol="square"
              symbolFill={chartColors.mediumGrey}
              transform={`translate(120, 20)`}
            />
          </Legend>
          <StackedBarChart
            data={energyMixData}
            unit={"%"}
            source={"Umweltbundesamt"}
            sourceLink={
              "https://www.umweltbundesamt.de/daten/energie/erneuerbare-konventionelle-stromerzeugung#bruttostromerzeugung-nach-energietragern-"
            }
            isAnimated={isAnimated}
          />
        </Group>
      </Group>
    </Svg>
  );
};
